import { UndoOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import React from 'react'

export default function RefreshButton({ onReset = () => {} }) {
	return (
		<Button onClick={onReset} className='lms-button-submit' style={{ width: '48px' }}>
			<UndoOutlined />
		</Button>
	)
}
